export default "__VITE_ASSET__fd6ba607__"